import React from 'react';
import { COUNTRY_DETAILS } from '../../utils/countryDetails';

export default function CountryFlag(props) {
  const {
    countryName,
    countryCode,
    showName = false,
    showCode = false,
  } = props;

  const countryDetail = props.countryName ? COUNTRY_DETAILS[props.countryName] : Object.values(COUNTRY_DETAILS).find(c => c.alpha2Code === countryCode);

  return <div className="flex align-items-center">
    {countryDetail && <img
        src={countryDetail.flag}
        style={{ width: 20, height: 16 }}
        className='margin-right-xs margin-left-xs'
        alt=''
    />}
    <span>
      {showName && countryName}
      {showCode && countryCode}
    </span>
  </div>;
}

